import { render } from "./app-footer.vue?vue&type=template&id=844e7d52"
const script = {}

import "./app-footer.vue?vue&type=style&index=0&id=844e7d52&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/app-footer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "844e7d52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('844e7d52', __exports__)) {
    api.reload('844e7d52', __exports__)
  }
  
  module.hot.accept("./app-footer.vue?vue&type=template&id=844e7d52", () => {
    api.rerender('844e7d52', render)
  })

}


export default __exports__